import { Component, ViewChild, OnInit, Injectable, Input } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MdPaginator } from "@angular/material";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";
import { IncassiService } from "../../../../../services/incassi.service";
import { AuthService } from "../../../../../services/auth.service";
import { IncassoListItemModel } from "../../../../../models/incassi/incasso-list-item.model";
import { ComponentInterface } from "../../models/component.interface";
import { DashboardService } from "../../../../../services/dashboard.service";

@Component({
  selector: "app-incassi-in-lavorazione",
  templateUrl: "./incassi-in-lavorazione.component.html",
  styleUrls: ["./incassi-in-lavorazione.component.css"],
})
export class IncassiInLavorazioneComponent
  implements OnInit, ComponentInterface {
  @Input() config;

  displayedColumns = [
    "idIncasso",
    "zona",
    "clienteRagioneSociale",
    "dataIncasso",
    "statoIncasso",
    "accedi",
  ];
  dataSource: IncassiInLavorazioneDataSource = null;
  isLoading: boolean = false;
  rowCount: number = 0;
  data: IncassoListItemModel[] = null;
  title: string;
  subtitle: string;

  countIncassiDaRendicontare: number;

  constructor(
    private _incassiService: IncassiService,
    private _dashboardService: DashboardService,
    public _authService: AuthService
  ) {
    //this.dataSource = new IncassiInLavorazioneDataSource(this._incassiService, this.paginator);
  }

  @ViewChild(MdPaginator) paginator: MdPaginator;

  ngOnInit() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
      });
    this._incassiService
      .getListInLavorazione()
      .subscribe((res: IncassoListItemModel[]) => {
        this.data = res;
        this.isLoading = false;
        this.rowCount = res.length;
        this.dataSource = new IncassiInLavorazioneDataSource(
          this.data,
          this.paginator
        );
      });

    this._incassiService.getListDaRendicontare().subscribe((i) => {
      if (i) {
        this.countIncassiDaRendicontare = i.length;
      } else {
        this.countIncassiDaRendicontare = 0;
      }
    });
  }
}

export class IncassiInLavorazioneDataSource extends DataSource<any> {
  constructor(
    //private _incassiService: IncassiService,
    private data: IncassoListItemModel[],
    private _paginator: MdPaginator
  ) {
    super();
  }

  connect(): Observable<IncassoListItemModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/incassi-in-lavorazione/incassi-in-lavorazione.component.ts